import { render, staticRenderFns } from "./WorkRecordTable.vue?vue&type=template&id=144faaf4&scoped=true"
import script from "./WorkRecordTable.vue?vue&type=script&lang=js"
export * from "./WorkRecordTable.vue?vue&type=script&lang=js"
import style0 from "./WorkRecordTable.vue?vue&type=style&index=0&id=144faaf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144faaf4",
  null
  
)

export default component.exports